/**
 * The move time is one Date edited through a day picker and a time input. These keep the
 * part of it the other input owns, the way the single date-time picker they replace did:
 * a new day keeps the time, a new time keeps the day, and either starts from today at
 * 00:00 when nothing is set yet.
 */

function startOfToday(now: Date): Date {
    return new Date(now.getFullYear(), now.getMonth(), now.getDate());
}

/** `day`'s calendar date at `current`'s time of day. */
export function withDay(day: Date, current: Date | null): Date {
    const time = current ?? startOfToday(day);
    return new Date(
        day.getFullYear(),
        day.getMonth(),
        day.getDate(),
        time.getHours(),
        time.getMinutes(),
        time.getSeconds(),
        time.getMilliseconds()
    );
}

/** `current` at the `HH:mm` a time input reports; null while the input holds no full time. */
export function withTime(time: string, current: Date | null, now: Date = new Date()): Date | null {
    const match = /^(\d{2}):(\d{2})$/.exec(time);
    if (!match) {
        return null;
    }
    const next = new Date(current ?? startOfToday(now));
    next.setHours(Number(match[1]), Number(match[2]));
    return next;
}

/** The `HH:mm` a time input shows for `date`, or an empty input without one. */
export function toTimeValue(date: Date | null): string {
    if (date === null) {
        return '';
    }
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
}
